import { render, staticRenderFns } from "./FirstLogin.vue?vue&type=template&id=4c643e45&scoped=true&"
import script from "./FirstLogin.vue?vue&type=script&lang=js&"
export * from "./FirstLogin.vue?vue&type=script&lang=js&"
import style0 from "./FirstLogin.vue?vue&type=style&index=0&id=4c643e45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c643e45",
  null
  
)

export default component.exports